import WarningMessage from "../../components/common/warnMsg";
import { CHECK_KEYLOK } from "../../config";
import httpService from "../../services/http.service";

class CommonUtils {

  IPValidation(string) {
    // let string = e.target.value;
    if (string.match(/[^0-9.]/)) {
      return true;
    }
    let count = 0;
    for (let i = 0; i < string.length; i++) {
      if (string.charAt(i) === ".") {
        count++;
      }
    }
    if (count > 3) {
      return true;
    }
    let x = string.split(".");
    for (let i = 0; i < x.length; i++) {
      if (x[i].length > 3) {
        return true;
      }
      if ((i > 0 && x[i - 1] === '') || Number.parseInt(x[i]) > 255) {
        return true;
      }
    }
    return false;
  }

  IPValidationWithCIDR(string) {
    let array = string.split('/');
    if (array.length > 2) return true;

    let ip = array[0];
    if (ip.match(/[^0-9.]/)) {
      return true;
    }
    let count = 0;
    for (let i = 0; i < ip.length; i++) {
      if (ip.charAt(i) === ".") {
        count++;
      }
    }
    if (count > 3) {
      return true;
    }
    let x = ip.split(".");
    for (let i = 0; i < x.length; i++) {
      if (x[i].length > 3) {
        return true;
      }
      if ((i > 0 && x[i - 1] === '') || Number.parseInt(x[i]) > 255) {
        return true;
      }
    }
    if (array.length === 2) {
      if (array[0].split('.').length === 4 && array[0].split('.')[3] === '') return true
      if (array[0].split('.').length !== 4) return true;
      let port = array[1];
      if (port && (isNaN(port) || (!isNaN(port) && (port <= 0 || port > 31)))) return true;
    }
    return false;
  }

  IPValidationForRange(string) {
    let array = string.split('-');
    if (array.length > 2) return true;
    if (string.match(/[-]/)) {
      if (array[0].split(".").length !== 4) { return true }
      if (!this.IPValidation(array[0]) && !this.IPValidation(array[1])) {
        return false
      } else { return true }
    } else {
      if (!this.IPValidation(string)) {
        return false
      }
    }
    return true;
  }

  MacValidation(string) {
    let array = string.split(':');
    if (string.match(/[^0-9abcdefABCDEF:]/)) return true;
    if (array.length > 6) return true;
    for (let i = 0; i < array.length; i++) {
      if (array[i] && array[i].length > 2) return true;
      if (i > 0 && array[i - 1].length !== 2) return true;
    }
    return false;
  }

  validateRule = (onClickRuleData) => {
    try {
      if (!onClickRuleData.ChannelRulesName.trim()) {
        WarningMessage("Please enter Channel Rule Name")
        return false;
      } if (Object.keys(onClickRuleData.RuleType).length === 0) {
        WarningMessage("Please select Rule type and enter correct value")
        return false;
      } if (onClickRuleData.RuleType.IpAddress?.SingleIpAddress !== undefined) {
        if (onClickRuleData.RuleType.IpAddress?.SingleIpAddress.length > 0) {
          if (onClickRuleData.RuleType.IpAddress?.SingleIpAddress.split(".").length < 4 || onClickRuleData.RuleType.IpAddress?.SingleIpAddress.split(".")[3].length === 0) {
            WarningMessage("Please enter correct IPAddress Format")
            return false;
          } else if (onClickRuleData.RuleType.IpAddress?.SingleIpAddress.trim().length === 0) {
            WarningMessage("Please enter value")
            return false;
          }
        } else {
          WarningMessage("Please enter value")
          return false;
        }
      } if (onClickRuleData.RuleType.IpAddress?.IpAddressRange !== undefined) {
        if (onClickRuleData.RuleType.IpAddress?.IpAddressRange.length > 0) {
          if (onClickRuleData.RuleType.IpAddress?.IpAddressRange.trim().length === 0) {
            WarningMessage("Please select rule and enter value")
            return false;
          } else {
            if (onClickRuleData.RuleType.IpAddress?.IpAddressRange.split("-").length < 2 || onClickRuleData.RuleType.IpAddress?.IpAddressRange.split("-")[1] === '') {
              WarningMessage("Please fill the correct IP Format")
              return false;
            } else {
              let checkIPrange = onClickRuleData.RuleType.IpAddress.IpAddressRange;
              let splitRange = checkIPrange.split("-");
              let arr1 = splitRange[0].split('.');
              let arr2 = splitRange[1].split('.');
              let i = 0;
              if (arr1.length < 4 || arr2.length < 4 || arr1[3].length === 0 || arr2[3].length === 0) {
                WarningMessage("Please fill the correct IP Format")
                return false;
              }
              while (i < 4 && arr1[i] === arr2[i]) i++;
              if (i === 4) {
                WarningMessage("MinIP address not same as MaxIP address");
                return false

              } else if (Number(arr1[i]) > Number(arr2[i])) {
                WarningMessage("MinIP address not greater then MaxIP address");
                return false;
              }
            }
          }
        } else {
          WarningMessage("Please fill the correct IP Format")
          return false;
        }
      } if (onClickRuleData.RuleType.IpAddress?.CIDR !== undefined) {
        if (onClickRuleData.RuleType.IpAddress?.CIDR.length > 0) {
          if (onClickRuleData.RuleType.IpAddress?.CIDR.trim().length === 0) {
            WarningMessage("Please select rule and enter value")
            return false;
          } else {
            if (onClickRuleData.RuleType.IpAddress?.CIDR.split('/').length < 2 || onClickRuleData.RuleType.IpAddress?.CIDR.split('/')[1].length === 0) {
              WarningMessage("Please fill the correct CIDR Format")
              return false;
            }
          }
        } else {
          WarningMessage("Please fill the correct CIDR Format")
          return false;
        }
      } if (onClickRuleData.RuleType?.AccountNumber !== undefined) {
        if (onClickRuleData.RuleType?.AccountNumber.trim().length === 0) {
          WarningMessage("Please enter a value")
          return false;
        }
      } if (onClickRuleData.RuleType?.Geo_Location !== undefined) {
        if (onClickRuleData.RuleType?.Geo_Location.trim().length === 0) {
          WarningMessage("Please enter a value")
          return false;
        }
      } if (onClickRuleData.RuleType?.MacAddress !== undefined) {
        if (onClickRuleData.RuleType?.MacAddress.trim().length === 0) {
          WarningMessage("Please enter a value")
          return false;
        } else {
          let checkMac = onClickRuleData.RuleType?.MacAddress.split(":");
          if (checkMac.length < 6 || checkMac[5].length !== 2) {
            WarningMessage("Please enter a correct macAddress Format")
            return false;
          }
        }
      }
      return true;
    } catch (error) {
      return false
    }
  }

  bilboardProgramTimeValidation = (onClickData) => {
    console.log("onclick -- ", onClickData)
    let flagtimeprogram = false;
    let flagtimeequal = false;
    onClickData?.program.map((e, i) => {
      if (e.startTime == e.endTime) {
        flagtimeequal = true;
      }
      onClickData?.program.map((elem, index) => {
        if (i != index) {
          let estart = parseInt(parseInt(e.startTime.substring(0, 2)) * 60) + parseInt(e.startTime.substring(3, 5));
          let eend = parseInt(parseInt(e.endTime.substring(0, 2)) * 60) + parseInt(e.endTime.substring(3, 5));
          let elemstart = parseInt(parseInt(elem.startTime.substring(0, 2)) * 60) + parseInt(elem.startTime.substring(3, 5));
          let elemend = parseInt(parseInt(elem.endTime.substring(0, 2)) * 60) + parseInt(elem.endTime.substring(3, 5));
          if (eend > estart || eend == estart) {
            if (elemstart >= estart && elemstart < eend) {
              flagtimeprogram = true;
            } else if (elemend > estart && elemend <= eend) {
              flagtimeprogram = true;
            }
          }
          else {
            if (elemstart >= estart || elemstart < eend) {
              flagtimeprogram = true;
            } else if (elemend > estart || elemend <= eend) {
              flagtimeprogram = true;
            }
          }
        }
      }
      )
    })

    if (flagtimeprogram) {
      WarningMessage("Two programs can not have same Time span")
      return true;
    } else {
      return false;
    }
    if (flagtimeequal) {
      WarningMessage("Program can not have same start time and end time")
      return true;
    } else {
      return false;
    }
  }

  validateBillboardScheduling = (onClickData) => {
    let flag = false;
    onClickData?.billboard?.map((e, i) => {
      if (onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType != "url" : false && onClickData.billboard[i].billboard == "") {
        if (e.billboard === "") {
          WarningMessage("Please Select a layout");
          flag = true;
          return;
        }
      } if (e.Timezone == "") {
        WarningMessage("Please Select a Timezone");
        flag = true;
        return;
      }
      if (onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType == "url" : true) {
        if (onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].billboard == "" : false) {
          WarningMessage("Please enter valid Url");
          flag = true;
          return;
        }
        if (onClickData.billboard[i] && onClickData.billboard[i].layoutType ? false : true) {
          WarningMessage("Please Select Layout Type");
          flag = true;
          return;
        }
      }
    })

    if (flag) {
      return true;
    } else {
      return false;
    }

    let flagtime2 = false;
    let firstdata = onClickData.billboard.length > 0 ? onClickData.billboard[0].Timezone : "";
    onClickData.billboard.map((e, i) => {
      for (i = 0; i < onClickData.billboard.length; i++) {
        if (onClickData.billboard[i].Timezone != firstdata) {
          flagtime2 = true;
          return;
        }
      }
    })

    if (flagtime2) {
      WarningMessage("Please Select same Timezone for all billboards");
      return true;
    } else {
      return false;
    }

    let flagtime = false;
    let flagtimeequal = false;
    onClickData.billboard.map((e, i) => {
      if (e.startTime == e.endTime) {
        flagtimeequal = true;
      }
      onClickData.billboard.map((elem, index) => {
        if (i != index) {
          let estart = parseInt(parseInt(e.startTime.substring(0, 2)) * 60) + parseInt(e.startTime.substring(3, 5));
          let eend = parseInt(parseInt(e.endTime.substring(0, 2)) * 60) + parseInt(e.endTime.substring(3, 5));
          let elemstart = parseInt(parseInt(elem.startTime.substring(0, 2)) * 60) + parseInt(elem.startTime.substring(3, 5));
          let elemend = parseInt(parseInt(elem.endTime.substring(0, 2)) * 60) + parseInt(elem.endTime.substring(3, 5));
          if (eend > estart) {
            if (elemstart >= estart && elemstart < eend) {
              flagtime = true;
            } else if (elemend > estart && elemend <= eend) {
              flagtime = true;
            }
          }
          else {
            if (elemstart >= estart || elemstart < eend) {
              flagtime = true;
            } else if (elemend > estart || elemend <= eend) {
              flagtime = true;
            }
          }
        }
      }
      )
    })
    if (flagtime) {
      WarningMessage("Two billboard can not have same Time span")
      return true;
    } else {
      return false;
    }
    if (flagtimeequal) {
      WarningMessage("Billboard can not have same start time and end time")
      return true;
    } else {
      return false;
    }
  }

  getLicensedProp = async () => {
    if (CHECK_KEYLOK) {
      try {
        let stream = await httpService.get("getlicenses").catch(e => { return true })
        let property = await httpService.get("getpropertycount").catch(e => { return true })
        return Number(stream.data.output.NumberOfLicence) <= Number(property.data);
      } catch (error) { return }
    } else return false

  }

  generateAccountNumber(len = 6, an) {
    an = an && an.toLowerCase();
    let str = "",
      i = 0,
      min = an === "a" ? 10 : 0,
      max = an === "n" ? 10 : 62;

    for (; i++ < len;) {
      let r = Math.floor(Math.random() * (max - min) + min);
      str += String.fromCharCode(
        r + (r > 9 ? (r < 36 ? 55 : 61) : 48)
      );
    }

    return str.toUpperCase(); 
  }


}

export default new CommonUtils();
